export default "__VITE_ASSET__Bf45AXXY__"